/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import api from ".";

// Start a background CSV export. `params` must carry `report` (e.g. 'orders')
// plus any report filters; the server snapshots them and enqueues a worker.
// Returns { id, status }.
export const createCsvExport = async (params) => {
  const response = await api.post("/v1/admin/csv_exports", params);
  return response?.data;
};

// Poll the status of a background CSV export.
// Returns { id, status: 'pending'|'processing'|'ready'|'failed', url, row_count, error }.
export const getCsvExportStatus = async (id) => {
  const response = await api.get(`/v1/admin/csv_exports/${id}`);
  return response?.data;
};
